<template>
  <v-layout elevation="0" row wrap>
    <v-flex xs12 sm6 pa-1>
      <Subheader title="Specimena" />
      <v-card elevation="0">
        <v-card-text>
          <v-list three-line>
            <template v-for="(specimen, i) in plot.Specimena">
              <v-divider v-if="i != 0" :key="`divider-${specimen.Id}`" />
              <SpecimenHeader :value="specimen" :key="specimen.Id" />
            </template>
          </v-list>
        </v-card-text>
      </v-card>
    </v-flex>
    <v-flex xs12 sm6 pa-1>
      <Subheader title="Surveys" />
      <v-card elevation="0">
        <v-card-text>
          <v-list three-line>
            <template v-for="(survey, i) in plot.Surveys">
              <v-divider v-if="i != 0" :key="`divider-${survey.Id}`" />
              <PlotSurveyHeader :value="survey" :key="`plot-survey-${survey.ParentSurveyId}-${i}`" />
            </template>
          </v-list>
        </v-card-text>
      </v-card>
    </v-flex>
    <v-flex xs12 sm6 pa-1>
      <Subheader title="Metadata" />
      <v-card elevation="0">
        <v-card-text>
          <KVStoreTable :value="plot.Metadata" />
        </v-card-text>
      </v-card>
    </v-flex>
    <template v-for="(survey, i) in plot.Surveys">
      <v-flex xs12 sm6 pa-1 :key="`plot-survey-${i}`">
        <Subheader :title="`Plot survey ${survey.SurveyDateTimeRaw}`" />
        <v-card elevation="0">
          <v-card-text>
            <KVStoreTable :value="survey.Metadata" />
          </v-card-text>
        </v-card>
      </v-flex>
    </template>
  </v-layout>
</template>

<script>
  import SpecimenHeader from '@/components/vegetativemonitoring/Header/SpecimenHeader'
  import PlotSurveyHeader from '@/components/vegetativemonitoring/Header/PlotSurveyHeader'
  export default {
    components: {
      SpecimenHeader,
      PlotSurveyHeader,
    },
    props: {
      value: {
        type: Object,
        required: true,
      },
    },
    computed: {
      plot() {
        return this.value
      },
    },
  }
</script>